import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditShadowIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect 
        x="3" width="14" height="15" rx="2"
        fill={props.fillColor ?? "black"}
      />
      <rect
        x="0.5" y="3.5" width="13" height="14" rx="1.5"
        stroke={props.fillColor ?? "black"}
      />
    </svg>
  );
}

export default EditShadowIcon;